import { render, staticRenderFns } from "./tagsTable.vue?vue&type=template&id=c1329fce&scoped=true"
import script from "./tagsTable.vue?vue&type=script&lang=js"
export * from "./tagsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1329fce",
  null
  
)

export default component.exports